export default __webpack_public_path__ + "static/media/order.15b1a387.png";